<div class="content wz-form-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">global context</span></h2>
    <span class="wz-step">Part 2 of 3</span>
  </div>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Form Layout -->
    <div class="form-container mx-auto">

      <!-- Recent Major Events Row -->
      <div class="form-row mb-4">
        <label for="recentEvents" class="form-label fw-bold">Recent major events <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="recentEvents" class="form-textarea" rows="4" [(ngModel)]="recentEvents"
            placeholder="Year 811 - An unnatural blizzard smothered the far north for months, freezing crops, awakening ancient predators, and driving refugees south in waves.
Year 822 - Solar flares hit the world and the State of Yerawa suffered"
          [class.is-invalid]="showErrorMsg && !recentEvents.trim()"></textarea>
        </div>
      </div>

      <!-- Political Overview Row -->
      <div class="form-row mb-4">
        <label for="politicalOverview" class="form-label fw-bold">Political overview <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="politicalOverview" class="form-textarea" rows="3" [(ngModel)]="politicalOverview"
            placeholder="Three rival superpowers maintain uneasy peace through spies, proxies, and brinkmanship"
          [class.is-invalid]="showErrorMsg && !politicalOverview.trim()"></textarea>
        </div>
      </div>

      <!-- Global Conflicts/Tensions Row -->
      <div class="form-row mb-4">
        <label for="globalConflicts" class="form-label fw-bold">Global conflicts / tensions <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="globalConflicts" class="form-textarea" rows="3" [(ngModel)]="globalConflicts"
            placeholder="Succession Crisis - A ruler has died without a clear heir; noble houses mobilize armies and claim legitimacy"
          [class.is-invalid]="showErrorMsg && !globalConflicts.trim()"></textarea>
        </div>
      </div>

    </div>

    <!-- Validation Error Banner -->
    @if (showErrorMsg) {
      <div class="error-banner mb-3 mx-auto">
        <span class="error-text">{{ validationErrorText }}</span>
      </div>
    }

  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

</div>
